/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { getMedia } from 'shared/api/get-media';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const getAdditionalityById = (
	id: string
): Promise<any> => {
	return apiClient.get(`/additionalities/${id}`, {
		params: {
			populate: 'publicSpecs, internalSpecs',
		},
	});
};

export const useAdditionalityById = (
	id: string,
	enabled: boolean
) => {
	const {
		data,
		isFetched,
		isFetching,
		isRefetching,
		refetch,
	} = useQuery({
		queryKey: ['get-additionality-project-by-id', id],
		queryFn: () => getAdditionalityById(id),
		staleTime: 0,
		enabled,
	});
	const cover = data && data.cover ? data.cover : null;

	const logo = data && data.logo ? data.logo : null;

	const { data: mediaCoverUrl } = useQuery({
		queryKey: ['get-media-cover-url', cover],
		queryFn: () => getMedia(cover),
		enabled: data && data.cover ? !!data.cover : false,
	});

	const { data: mediaLogo } = useQuery({
		queryKey: ['get-media-logo', logo],
		queryFn: () => getMedia(logo),
		enabled: data && data.logo ? !!data.logo : false,
	});

	return {
		data: {
			...data,
			mediaLogo,
			mediaCoverUrl,
		},
		isLoading: isFetching && !isFetched,
		isFetched: isFetched,
		isFetching,
		isRefetching,
		refetch,
	};
};
